/** A new Stores arrival of one kind. Nothing is written until the first item is posted. */
import { STORES_ARRIVAL_KINDS, storesArrival } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { ArrivalPage } from "@/features/stores/components/arrival-page";

export const Route = createFileRoute("/_app/stores/arrivals/new")({
  validateSearch: z.object({
    kind: z.enum(STORES_ARRIVAL_KINDS).default("arrival_vendor"),
  }),
  beforeLoad: ({ search }) => {
    if (!useAuth.getState().can(storesArrival(search.kind).permission as never))
      throw redirect({ to: "/stores/arrivals" });
  },
  component: Page,
});

function Page() {
  const { kind } = Route.useSearch();
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <ArrivalPage
      key={kind}
      arrival={null}
      kind={kind}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
